<script setup>
import QuotationForm from '@frontJs/components/forms/projectManagement/apikom/QuotationForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { quotation, users } = defineProps({
    quotation: {
        type: Object,
        required: false,
    },
    users: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="quotation">
            Mettre à jour le devis #{{ quotation.id }} - Devis - Apikom -
            Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un devis - Devis - Apikom - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="quotation">
        Gestion de projet - Apikom - Devis - Mettre à jour le devis #{{
            quotation.id
        }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Apikom - Devis - Créer un devis
    </PageTitle>

    <QuotationForm :quotation="quotation" :users="users" />
</template>
